import Reflux from "reflux";

export default Reflux.createActions([
  // expect event object with additional trackingOptions object
  "trackClickEvent",
]);
